// src/v3/logos/satws.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx, jsxs } from "react/jsx-runtime";
var SatwsLogo = (props) => /* @__PURE__ */ jsxs(SvgIcon, { "data-testid": "SatwsLogo", viewBox: "0 0 32 32", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 12.2142C18.5015 12.2142 20.5294 10.1516 20.5294 7.60711C20.5294 5.06267 18.5015 3 16 3C13.4985 3 11.4706 5.06267 11.4706 7.60711C11.4706 10.1516 13.4985 12.2142 16 12.2142ZM6.52942 28.1297C9.03095 28.1297 11.0588 26.067 11.0588 23.5226C11.0588 20.9782 9.03095 18.9155 6.52942 18.9155C4.02789 18.9155 2 20.9782 2 23.5226C2 26.067 4.02789 28.1297 6.52942 28.1297ZM30 23.5226C30 26.067 27.9721 28.1297 25.4706 28.1297C22.969 28.1297 20.9412 26.067 20.9412 23.5226C20.9412 20.9782 22.969 18.9155 25.4706 18.9155C27.9721 18.9155 30 20.9782 30 23.5226Z",
      fill: "#97A9DA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.3884 8.95581C10.9876 11.5441 13.2726 13.4707 16 13.4707C18.6451 13.4707 20.8741 11.6587 21.5527 9.18849C24.2447 11.0393 26.0294 14.1521 26.0869 17.6922C25.8843 17.6702 25.6788 17.6589 25.4706 17.6589C22.2869 17.6589 19.7059 20.2842 19.7059 23.5225C19.7059 24.8254 20.1237 26.029 20.8303 27.0023C19.3417 27.8536 17.6237 28.3391 15.7941 28.3391C14.0827 28.3391 12.4687 27.9142 11.0487 27.1626C11.8286 26.1627 12.2941 24.8979 12.2941 23.5225C12.2941 20.2842 9.71318 17.6589 6.52941 17.6589C6.1792 17.6589 5.83628 17.6907 5.50329 17.7516L5.5 17.8684C5.5 14.1023 7.4547 10.8007 10.3884 8.95581Z",
      fill: "#4062BB"
    }
  )
] });

export {
  SatwsLogo
};
